namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class ProviderEmailEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            //this.addItem({
            //    id: "SendGrid", text: "SendGrid", source: {
            //        Url: "https://test.sendgrid",
            //    } });
            //this.addItem({
            //    id: "Sendinblue", text: "Sendinblue", source: {
            //        Url: "https://test.sendinblue",
            //    }
            //});
            this.addItem({
                id: "Mailgun", text: "Mailgun", source: {
                    Url: "https://api.mailgun.net/v3",
                }
            });
            //this.addItem({
            //    id: "Mailjet", text: "Mailjet", source: {
            //        Url: "https://test.mailjet",
            //    }
            //});
        }
    }
}